// extracted by mini-css-extract-plugin
module.exports = {"root":"Flag_root__3CYub"};